import ActionableCard from './ActionableCard';
import Body from './Body';
import Footer from './Footer';

ActionableCard.Body = Body;
ActionableCard.Footer = Footer;

export default ActionableCard;
